import { parseEntityRef, stringifyEntityRef } from '@backstage/catalog-model';

/**
 * Returns the percentage of passed items out of total, rounded to one decimal
 * place. Returns 100 when total is zero (nothing to fail).
 */
export const toPercentageDecimal = (passed: number, total: number): number => {
  if (passed >= total) {
    return 100;
  }
  const rounded = Math.round((passed / total) * 1000) / 10;
  return rounded >= 100 ? 99.9 : rounded;
};

/**
 * Returns the CSS foreground color token for a compliance percentage.
 * - >= 80%: success (green)
 * - 40-79%: warning (amber)
 * - < 40%: danger (red)
 */
export const getComplianceColorVar = (percentage: number): string => {
  if (percentage >= 80) {
    return 'var(--bui-fg-positive)';
  }
  if (percentage >= 40) {
    return 'var(--bui-fg-warning)';
  }
  return 'var(--bui-fg-negative)';
};

export const normalizeOwnerEntityRef = (
  entityRef: string,
): string | undefined => {
  const trimmed = entityRef.trim();
  if (!trimmed) return undefined;
  try {
    return stringifyEntityRef(
      parseEntityRef(trimmed, {
        defaultKind: 'group',
        defaultNamespace: 'default',
      }),
    );
  } catch {
    return undefined;
  }
};
